module.exports = "/static/assets/11a377d4473321b3397440c222212b96.png";